import { render, staticRenderFns } from "./Csv.vue?vue&type=template&id=26c84ded&"
import script from "./Csv.vue?vue&type=script&lang=js&"
export * from "./Csv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26c84ded')) {
      api.createRecord('26c84ded', component.options)
    } else {
      api.reload('26c84ded', component.options)
    }
    module.hot.accept("./Csv.vue?vue&type=template&id=26c84ded&", function () {
      api.rerender('26c84ded', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/IoFormat/Components/Formats/Csv.vue"
export default component.exports